export default __webpack_public_path__ + "static/media/basket.ffbc2775.svg";